import {
  Box,
  Button,
  ButtonGroup,
  FormControlSizes,
  IconName,
  isInIFrame,
  Menu,
  MenuItem,
  MixpanelEvent,
  MixpanelEventProperty,
  NavButton,
  useAuthContext,
  useMixpanel,
  useWLLayoutType,
  useWLOrgConfigContext,
  useWLUser,
  type ThemeTypes,
} from '@talos/kyoko';
import {
  SidebarContext,
  sidebarContextDefaultValues,
  SidebarCurrentFeeTier,
  SidebarThemeToggle,
} from '@talos/kyoko/src/routed';
import { useCallback } from 'react';
import { LayoutType } from '../../../layouts/layout';

export function UserMenu({
  showLayoutToggle,
  showThemeToggle,
  themeType,
  onChangeThemeType,
}: {
  showThemeToggle: boolean;
  showLayoutToggle: boolean;
  themeType: ThemeTypes;
  onChangeThemeType: (themeType: ThemeTypes) => void;
}) {
  const { logout } = useAuthContext();
  const user = useWLUser();
  const { layoutType, setLayoutType, tradingLayout } = useWLLayoutType();
  const { config } = useWLOrgConfigContext();

  const mixpanel = useMixpanel();

  const handleChangeLayout = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      const layoutType = (e.target as HTMLButtonElement).value as LayoutType;
      mixpanel.track(MixpanelEvent.ChangeLayout, { [MixpanelEventProperty.Type]: layoutType });
      setLayoutType(layoutType);
    },
    [setLayoutType, mixpanel]
  );

  return (
    <SidebarContext.Provider value={sidebarContextDefaultValues}>
      <Menu triggerIcon={IconName.User} triggerMinimal={false}>
        <Box px="spacing12" py="spacing8">
          <Box fontSize="fontSizeDefault" color="colorTextImportant">
            {user.DisplayName}
          </Box>
          {!config.hideUserEmail && <Box fontSize="fontSizeDefault">{user.Email}</Box>}
        </Box>
        {config.menuItems?.map(item => (
          <NavButton
            ghost
            key={`${item.label}_${item.url}`}
            to={item.url}
            target="_blank"
            rel="noreferrer"
            endIcon={IconName.ExternalLink}
          >
            {item.label}
          </NavButton>
        ))}
        <SidebarCurrentFeeTier />
        {showThemeToggle && <SidebarThemeToggle themeType={themeType} onChangeThemeType={onChangeThemeType} />}
        {showLayoutToggle && (
          <ButtonGroup size={FormControlSizes.Small}>
            <Button
              disabled={layoutType === LayoutType.SimpleRFQLayout}
              value={LayoutType.SimpleRFQLayout}
              onClick={handleChangeLayout}
            >
              RFQ layout
            </Button>
            <Button disabled={layoutType === tradingLayout} value={tradingLayout} onClick={handleChangeLayout}>
              Trading layout
            </Button>
          </ButtonGroup>
        )}
        {!isInIFrame() && (
          <MenuItem onClick={logout} endIcon={IconName.Logout}>
            Logout
          </MenuItem>
        )}
      </Menu>
    </SidebarContext.Provider>
  );
}
